import React from "react";
import { compose, withAppContext, withState, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import InputPack from "components/InputPack";
import { inviteUser } from "./_actions";

class InviteUserModal extends React.Component {
    _validate = (values) => {
        const errors = {};

        errors.email = FormUtils.validators.required(values.email);
        errors.email = errors.email || FormUtils.validators.email(values.email);

        if (!errors.email) {
            if (this.props.existingUsers.some((u) => u.email.toLowerCase() === values.email.toLowerCase())) errors.email = "User already exists";
        }

        return errors;
    };

    _save = (values) => {
        this.props.inviteUser(values, this.props.authContext.isSystemAdmin);
    };

    render() {
        const { online, invitation } = this.props;

        return (
            <Form initialValues={invitation} validate={this._validate} onSubmit={this._save}>
                {({ handleSubmit, submitSucceeded }) => {
                    return (
                        <Modal title="Ask staff member to join your organisation" instructions="This should only be used to add users to your organisation (not your farm). If you want to grant someone access to your farm please select manage farm access from within the farm screen instead. On completion an email invitation will be sent to the user for them confirm their registration as a user in your organisation.">
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <input type="hidden" id="invitation-id" value={invitation.id} />
                                        <Grid>
                                            <GridCell>
                                                <Field name="id" type="hidden" component="input" />
                                                <Field name="email" label="Email" placeholder="Enter email of person you wish to invite to your organisation. Do not use this to grant access to a farm." disabled={invitation.email !== undefined} required component={InputPack} />
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={!online || submitSucceeded}>
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(
    withAppContext,
    withActions({ inviteUser }),
    withState((state, ownProps) => {
        const {
            viewModel: { invitation = {}, existingUsers = [] },
        } = ownProps;
        return {
            invitation,
            existingUsers,
        };
    })
)(InviteUserModal);
